import InputField from "components/fields/InputField";
import CustomButton from "components/button/custom_button";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchLoginUser } from "services/users/authSlice";
import Loader from "components/loader";
import Alert from "components/alert";
export default function SignIn() {
  const [values, setValues] = useState({
    username: "",
    password: "",
  });
  const dispatch = useDispatch();
  const inputs = [
    {
      id: "signin1",
      name: "username",
      type: "text",
      placeholder: "e.g. manager",
      errorMessage:
        "Хэрэглэгчийн нэр 3-16 тэмдэгтээс бүрдэх бөгөөд ямар нэгэн тусгай тэмдэгт оруулах ёсгүй!",
      label: "Хэрэглэгчийн нэр",
      pattern: "^[A-Za-z0-9]{3,16}$",
      required: true,
    },
    {
      id: "signin2",
      name: "password",
      type: "password",
      placeholder: "Password",
      errorMessage: "Нууц үг 4-10 тэмдэгттэй байх ёстой!",
      label: "Password",
      pattern: "^.{4,10}$",
      required: true,
    },
  ];
  const navigate = useNavigate();

  const onChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    if (!e.preventDefault()) {
      const resultAction = await dispatch(
        fetchLoginUser({
          username: values.username,
          password: values.password,
          device_token: "_",
        })
      );
      if (fetchLoginUser.fulfilled.match(resultAction)) {
        navigate("/admin");
      }
    }
  };

  const auth = useSelector((state) => {
    return state.auth;
  });

  return (
    <div className="rounded-xl bg-white p-2 2xl:p-[5vh] dark:!bg-navy-900">
      <form onSubmit={handleSubmit}>
        {auth.loading && <Loader />}
        {!auth.loading && auth.error ? <Alert text={auth.error} /> : null}
        {inputs.map((input) => (
          <InputField
            key={"key" + input.id}
            id={input.id}
            {...input}
            value={values[input.name]}
            onChange={onChange}
          />
        ))}
        <div className="mb-4 flex items-center justify-between px-2">
          <a
            className="text-sm font-medium text-brand-500 hover:text-brand-600 dark:text-white"
            href="/forgot"
          >
            Нууц үгээ мартсан
          </a>
        </div>

        <CustomButton text="Нэвтрэх" type="submit" />
      </form>
    </div>
  );
}
